<!--  -->
<template>
  <div>
    <div class="header">
      <div class="box">
        <div class="L"><a onClick="javascript:history.back(-1)" class="goback"><img src="/static/images_m/goback.png" /></a></div>
        <div class="C"><p>直播</p></div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="hbox"></div>
    <div class="videoBox">
      <div class="video_1">
        <img src="/static/images_m/3.jpg">
      </div>
      <div class="titbox">
        <p>通关直播</p>
        <span>解决你的所有顾虑</span>
      </div>
      <ul>
        <li v-for="(live,index) in lives" :key="index">  
          <div class="L">
            <div class="date1"><img src="/static/images_m/date.png"><p>{{dateFormat( new Date(live.time), "MM月dd日")}}</p></div>
            <div class="date2">{{dateFormat(new Date(live.time), "hh:mm")}}</div>
          </div>
          <div class="C"><img src="/static/images_m/line.jpg"></div>
          <div class="R">
            <div class="tit">{{live.title}}</div>
            <div class="sub">
              <img src="/static/images_m/4.jpg">
              <p>讲师：{{live.teacher}}</p>
              <router-link :to="`/mylive/${live._id}`" :class="live.state=='1'?'a1':'a2'">{{live.state=='1'?'正在直播':'暂未开播'}}</router-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      lives: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    this.$axios
      .get("/api/livings?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.lives = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=state";
      }
      if (this.searchPrice == "0") {
        searchConditions += "&price=0";
      } else {
        searchConditions += "&price[ne]=0";
      }
      this.$axios
        .get(
          `/api/livings?page=${
            this.intCurrent
          }&limit=6${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.courses = res.data.data;
            this.toTop();
          }
        });
    },
     dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style_Phone.scss";
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
::v-deep .el-pager li.active {
  color: #51be78;
}

 .buytip-labelwkb {
  background-color: #a7a2a2;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 4px 10px 4px 12px;
  -webkit-border-radius: 4px 4px 4px 0;
  -moz-border-radius: 4px 4px 4px 0;
  border-radius: 4px 4px 4px 0;
  font-size: 12px;
  position: absolute;
  right: 16px;
  bottom: 58px;
  z-index: 1;
}

 .buytip-labelwkb:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  right: 6px;
  z-index: -1;
  background-color: #a7a2a2;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transform: skewX(351deg);
  -moz-transform: skewX(351deg);
  -ms-transform: skewX(351deg);
  -o-transform: skewX(351deg);
  transform: skewX(351deg);
  -webkit-border-radius: 4px 0 0 0;
  -moz-border-radius: 4px 0 0 0;
  border-radius: 4px 0 0 0;
}
*{
  font-size: 12px;
      color: #333;
}
a:not([href]):not([tabindex]) {
    color: initial !important;
}
</style>
